import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getClientFiles, uploadClientFile, deleteClientFile, downloadClientFile,viewClientFile } from "../api/CLIENTS/clientFiles";

const filesKey = (clientId) => ["clientFiles", clientId];

export const useClientFiles = (clientId) =>
  useQuery({
    queryKey: filesKey(clientId),
    queryFn: () => getClientFiles(clientId),
    enabled: !!clientId,
    staleTime: 2 * 60 * 1000,
    select: (data) => {
      const files = data.data ?? [];
      return Array.isArray(files) ? files : [];
    },
  });

export const useUploadClientFile = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file) => uploadClientFile(clientId, file),
    onSuccess: () => qc.invalidateQueries({ queryKey: filesKey(clientId) }),
  });
};

export const useDeleteClientFile = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fileId) => deleteClientFile(clientId, fileId),
    onSuccess: () => qc.invalidateQueries({ queryKey: filesKey(clientId) }),
  });
};

export const useDownloadClientFile = (clientId) => {
  return {
    download: (fileId, filename) => downloadClientFile(clientId, fileId, filename),
    view: (fileId) => viewClientFile(clientId, fileId)
  };
};